@if (isWX) {
  <div class="guide">
    <img src="/assets/guide.png" alt="" />
  </div>
  <div class="guide-bg">
    <img src="/assets/guide_bg.png" alt="" />
  </div>
  <div class="web">
    暂不支持在微信中使用
    <br />
    <span>请在浏览器中打开</span>
  </div>
} @else {
  <router-outlet></router-outlet>
}
